
import { api } from "./useApi";

export const NovidadesApi = () => ({
    getNovidades: async () => {
        let response = await api.post("/novidades/select-novidades");
        return response.data
    },
});